// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".not-found[data-v-5c040526]{margin-top:50px}", ""]);
// Exports
module.exports = exports;
